import { render, staticRenderFns } from "./ScoringModal.vue?vue&type=template&id=09f3b472&scoped=true&"
import script from "./ScoringModal.vue?vue&type=script&lang=js&"
export * from "./ScoringModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09f3b472",
  null
  
)

export default component.exports